import { render, staticRenderFns } from "./imgZ.vue?vue&type=template&id=37a7b921"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a7b921')) {
      api.createRecord('37a7b921', component.options)
    } else {
      api.reload('37a7b921', component.options)
    }
    module.hot.accept("./imgZ.vue?vue&type=template&id=37a7b921", function () {
      api.rerender('37a7b921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgZ.vue"
export default component.exports